import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output } from "@angular/core";
import { ToastService } from "app/services/toast-wrapper/toast-wrapper.service";
import { getCookieValue } from "../utils/cookie.util";
import { Subscription, fromEvent } from "rxjs";

@Directive({
    selector: "[check-cookies-expired]"
})
export class CheckCookiesExpiredDirective implements OnInit {

    subscription: Subscription = new Subscription();

    constructor(
        private elementRef: ElementRef,
        private toastService: ToastService,
    ) { }

    ngOnInit() {
        fromEvent(this.elementRef.nativeElement, 'click', {
            capture: true,
        }).subscribe((e: MouseEvent) => {
            if (!getCookieValue('recordedWallet')) {
                e.stopImmediatePropagation();
                this.toastService.sessionExpired();
            }
        });
    }


}